import { useEffect } from "react";
import { Reveal } from "./Reveal";

const SORO_SRC = "https://app.trysoro.com/api/embed/559480c3-4bed-4713-92da-17311aa7067f";

export const Blog = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${SORO_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = SORO_SRC;
    s.defer = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section id="blog" className="py-24 sm:py-32 bg-fr-surface border-t border-white/10" data-testid="blog-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl mb-14">
          <span className="fr-mono text-xs tracking-[0.3em] uppercase text-fr-blue-light">/ Blog</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
            Tips, guides & stories from the field.
          </h2>
          <p className="mt-5 text-white/60 max-w-xl">
            Cleaning tips, before/after stories, and news from First Response — straight from the crew.
          </p>
        </Reveal>

        <div className="bg-fr-black border border-white/10 p-6 sm:p-10 min-h-[280px]">
          <div id="soro-blog" />
        </div>
      </div>
    </section>
  );
};
